//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the different levels of location permission that can be granted to an application. */
export const LocationPermissionStatus = {
    /** The Person has not granted permission to use location services. */
    NotGranted: 0,

    /** The Person denied permission to use location services. */
    Denied: 1,

    /** The Person has granted permission to use location services only when the app is in use. */
    WhenInUse: 2,

    /** The Person has granted permission to use location services at all times. */
    Always: 3
} as const;

/** Represents the different levels of location permission that can be granted to an application. */
export const LocationPermissionStatusDescription: Record<number, string> = {
    0: "Not Granted",

    1: "Denied",

    2: "When In Use",

    3: "Always"
};

/** Represents the different levels of location permission that can be granted to an application. */
export type LocationPermissionStatus = typeof LocationPermissionStatus[keyof typeof LocationPermissionStatus];
